<span class="text-xs text-gray-500">{{"version"|translate}} <span class="font-bold">{{version}}</span></span>
